import React, { useEffect } from "react"
import { Helmet } from "react-helmet-async"
import BancoPreciosContent from "components/BancoPrecios/bancoPreciosContent"
import EntitlementPageGuard from "components/Subscription/EntitlementPageGuard"
import { BANKS_CUSTOM } from "constants/entitlements"

import { Container } from "reactstrap"

import { RecordPageView } from "App"
import * as amplitude from "@amplitude/analytics-browser"

const BancoPreciosIndex = () => {
  useEffect(() => {
    amplitude.track("Mi Banco de Precios Visited")
  }, [])

  RecordPageView()
  return (
    <EntitlementPageGuard permission={BANKS_CUSTOM}>
      <div className="page-content">
        <Helmet>
          <title>Planhopper | Banco de precios </title>
        </Helmet>
        <Container fluid>
          <BancoPreciosContent />
        </Container>
      </div>
    </EntitlementPageGuard>
  )
}

export default BancoPreciosIndex
